<template>
  <ToolbarContainer>
    <template v-slot:toolbar>
      <TabBar
        class="tabBar"
      >
        <template v-slot:tabs>
          <Tabs
            :activeTab="activeTab"
            :tabs="tabList"
            @selectedTab="handleTabSelected"
          />
        </template>
      </TabBar>
    </template>
    <template v-slot:body>
      <div>
        <PasswordManagerItemsList
          :key="itemType"
          :itemType="itemType"
          :itemsDefaultFilters="itemsDefaultFilters"
        />
      </div>
    </template>
  </ToolbarContainer>
</template>

<script>
import {
  TabBar,
  Tabs,
  ToolbarContainer,
  Types,
} from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';
import { passwordManagerItemPluralLabelMap, passwordManagerItemType, passwordManagerItemTypeServerId } from 'client/PasswordManager/PasswordManagerConstants';
import PasswordManagerItemsList from 'client/PasswordManager/Items/PasswordManagerItemsList.vue';

const { TabItem } = Types;

const PasswordManagerItemCollection = 'PasswordManagerItemCollection';

export default {
  name: 'PasswordManagerItemsTabs',

  components: {
    PasswordManagerItemsList,
    TabBar,
    Tabs,
    ToolbarContainer,
  },

  props: {
    itemsDefaultFilters: {
      type: Array,
      required: false,
      default: () => [],
    },
    scopeId: {
      type: String,
      default: '',
    },
    scopeType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      activeTab: passwordManagerItemType.password,
    };
  },

  computed: {
    ...mapGetters(PasswordManagerItemCollection, [
      'allItemsCounts',
    ]),

    itemType() {
      return this.activeTab;
    },

    tabList() {
      return Object.values(passwordManagerItemType).map(itemType => {
        const itemServerId = passwordManagerItemTypeServerId[itemType];
        const itemCount = this.allItemsCounts?.find(itemsCount => itemsCount.type === itemServerId)?.count || '0';

        return TabItem({
          label: `${passwordManagerItemPluralLabelMap[itemType]} (${itemCount})`,
          key: itemType,
        });
      });
    },
  },

  created() {
    this.setPasswordManagerItemsScope({ scopeType: this.scopeType, scopeId: this.scopeId });
  },

  destroyed() {
    this.resetPasswordManagerItems();
  },

  methods: {
    ...mapActions(PasswordManagerItemCollection, [
      'resetPasswordManagerItems',
      'setPasswordManagerItemsScope',
    ]),

    handleTabSelected(tabKey) {
      this.activeTab = tabKey;
    },
  },
};
</script>

<style scoped>
.tabBar {
  margin-top: var(--jc-spacer);
  padding: 0 var(--jc-spacer);
}
</style>
